// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div[data-v-35d968a7]{display:inline-block;padding:12px 5px 10px 15px}img[data-v-35d968a7]{vertical-align:middle;max-width:100%;height:36px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
